module.exports = __webpack_public_path__ + "img/home-bg.a8f82583.jpg";